export default __webpack_public_path__ + "static/media/amalmoney.2e40f112.jpg";